import React, { useCallback, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  useCreateAcknowledgmentOverrideReportEmailMutation,
  useFetchSingleAcknowledgmentOverrideReportEmailQuery,
  useUpdateAcknowledgmentOverrideReportEmailMutation,
} from '../acknowledgmentoverridereportemail-api';
// import moment, { Moment } from 'moment';
import dayjs from "dayjs";
import { PageHeader } from '@ant-design/pro-layout';
import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Form,
  Input,
  message,
  Select,
  Space,
  Spin,
  Tooltip,
  DatePicker,
  Switch,
  Descriptions,
} from 'antd';
import Title from 'antd/lib/typography/Title';
import AcknowledgmentOverrideReportEmailFiltersScreen from '../../acknowledgmentoverridereportemailfilter/screens/acknowledgmentoverridereportemailfilters-screen'
import { HomeOutlined, UserOutlined,QuestionCircleOutlined } from '@ant-design/icons';
import { Company, PaginatedResult, AcknowledgmentOverrideReportEmailViewModel } from '../../api/models';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { ConvertUTCtoCDT } from '../../../core/utils';
import { getLink } from '../../../App-router';
import { DefaultTenantId } from '../../../core/defaults';
const { Option } = Select;

const isFetchBaseQueryErrorType = (error: any): error is FetchBaseQueryError =>
  error ? 'status' in error : false;

const getErrorMessage = (error: any): string | undefined => error.data;

interface AcknowledgmentOverrideReportEmailScreenParams {
Id?: string | undefined;
tenantId?: string | undefined;
  [key: string]: string | undefined;
}

export default function AcknowledgmentOverrideReportEmailEditScreen(props: any) {
  const { Id, tenantId = DefaultTenantId}: AcknowledgmentOverrideReportEmailScreenParams =
    useParams<AcknowledgmentOverrideReportEmailScreenParams>();
  
  const isNewAcknowledgmentOverrideReportEmail = Id === 'new';

  const { data, isFetching } = useFetchSingleAcknowledgmentOverrideReportEmailQuery(
    {
      Id: Number(Id),
    },
    { skip: isNewAcknowledgmentOverrideReportEmail }
  );

  const [createAcknowledgmentOverrideReportEmail, { isLoading: isCreating, error: createError }] = useCreateAcknowledgmentOverrideReportEmailMutation();
  const [updateAcknowledgmentOverrideReportEmail, { isLoading: isUpdating, error: updateError }] = useUpdateAcknowledgmentOverrideReportEmailMutation();
  const [edit, setEdit] = useState<boolean>(false);
  const navigate = useNavigate();

  const [form] = Form.useForm();

  React.useEffect(() => {
    // form.resetFields();
  }, [data, form]);
  const [disabledSave, setDisabledSave] = useState(true);
  
  const handleFormChange = () => {
  const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
  setDisabledSave(hasErrors);
  }
  const onFinish = (values: any | AcknowledgmentOverrideReportEmailViewModel) => {
    const requestData = {
      AcknowledgmentOverrideReportEmail: {
        id: isNewAcknowledgmentOverrideReportEmail ? 0 : Number(Id),
        name: values.name,
        receipientEmail: values.receipientEmail,
        frequency: values.frequency,        
        startDate: values.startDate==undefined?'':dayjs(values.startDate).format('MM/DD/YYYY'),
        lastExecutionDate: values.lastExecutionDate==undefined?'':dayjs(values.lastExecutionDate).format('MM/DD/YYYY'),
        isActive: values.isActive==undefined?true:values.isActive,
        updatedBy:sessionStorage.getItem('userEmail')||'',
        enteredBy:isNewAcknowledgmentOverrideReportEmail?sessionStorage.getItem('userEmail')||'':'',
      },
    };

    const request = isNewAcknowledgmentOverrideReportEmail ? createAcknowledgmentOverrideReportEmail(requestData) : updateAcknowledgmentOverrideReportEmail(requestData);
    request.unwrap().then((response) => {
      if(response?.id ===-200){
        message.error(
          `This combination already exists. Please try other values.`
        );
        return;
      }
      message.success(
        `AcknowledgmentOverrideReportEmail is ${isNewAcknowledgmentOverrideReportEmail ? 'created' : 'saved'}`
      );
      navigate(
        getLink('AcknowledgmentOverrideReportEmailEdit', {
          ...props,
          tenantId: tenantId, Id:response?.id
        })
      );
      setEdit(false);
    });
  };

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 10 },
  };

  const handleCancel = () => {
    if(isNewAcknowledgmentOverrideReportEmail && edit){
      navigate(
        getLink('AcknowledgmentOverrideReportEmailList', {
          ...props,
          tenantId: tenantId,
        })
      );
      }
      else if(edit){
        setEdit(false);
      }
      else if(isNewAcknowledgmentOverrideReportEmail){
        navigate(
          getLink('AcknowledgmentOverrideReportEmailList', {
            ...props,
            tenantId: tenantId,
          })
        );
      }
  };

  return (
    <div>
      <PageHeader
        breadcrumb={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={getLink('home', { tenantId: tenantId })}>
              <HomeOutlined />
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>              
              <Link to={getLink('cob', { tenantId: tenantId })}>
              Dashboard
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={getLink('AcknowledgmentOverrideReportEmailList', { ...props, tenantId })}>Acknowledgement Reconciliation Reports</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{isNewAcknowledgmentOverrideReportEmail ? 'New Acknowledgement Reconciliation Report' : data?.name}</Breadcrumb.Item>
          </Breadcrumb>
        }
      >
        {isFetchBaseQueryErrorType(createError) && (
          <Alert message="Error" description={getErrorMessage(createError)} type="error" showIcon />
        )}
        {isFetchBaseQueryErrorType(updateError) && (
          <Alert message="Error" description={getErrorMessage(updateError)} type="error" showIcon />
        )}
        <Card
          title={
            <Title
              level={4}
              style={{
                marginBottom: 0,
                display: 'inline-block',
              }}
            >
              {isNewAcknowledgmentOverrideReportEmail ? 'New Acknowledgement Reconciliation Report' : edit?'Edit Acknowledgement Reconciliation Report':'Acknowledgement Reconciliation Report'}
            </Title>
          }
          extra={
            <Space>
            <Button htmlType="button" type='primary' data-testid={'create-new-ackreportmail'} 
            onClick={()=>{ setEdit(true);}} disabled={isNewAcknowledgmentOverrideReportEmail || edit}>
              Edit 
            </Button>
            </Space>
          }
        >
          <Spin spinning={isFetching || isCreating || isUpdating}>
          {isNewAcknowledgmentOverrideReportEmail || edit?
            <Form
              {...layout}
              form={form}
              name="control-hooks"
              initialValues={data}
              onFinish={onFinish}
              onFieldsChange={handleFormChange}   
            >
              <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                <Input allowClear placeholder='Please provide a valid name with max-length 100. for e.g. MercuryGate Test Report' data-testid="name" 
                maxLength={100} suffix={
                        <Tooltip title="Please provide name with max-length 100. for e.g. MercuryGate Test Report">
                         <QuestionCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      } />
              </Form.Item>
              <Form.Item name="receipientEmail" label="ReceipientEmail" rules={[{ required: true }]}>
                <Input allowClear type='email' multiple placeholder='Please provide ReceipientEmail with max-length is 1000 for e.g. test@redwoodlogistics.com' 
                data-testid="receipientEmail" maxLength={1000} suffix={
                        <Tooltip title="Please provide receipientEmail with max-length is 1000 for e.g. test@redwoodlogistics.com">
                         <QuestionCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      } />
              </Form.Item>
              <Form.Item name="frequency" label="Frequency" rules={[{ required: true }]}>
                      <Select allowClear placeholder='Frequency' options={[{label:'Daily', value:'Daily'},{label:'Weekly', value:'Weekly'},{label:'Monthly', value:'Monthly'}]} />
              </Form.Item>

              <Form.Item  name="startDate" label="StartDate"  rules={ isNewAcknowledgmentOverrideReportEmail?[{type:'object', required: true,
               message: 'startDate is required' }]:[{ required: true, message: 'startDate is required' }]} 
                           initialValue={dayjs(data?.startDate)} getValueProps={(i) => ({ value: dayjs(i) })}>
                      <DatePicker defaultValue={dayjs(data?.startDate)}  format='MM/DD/YYYY' placeholder='MM/DD/YYYY' allowClear={false} 
                      style={{ width: '100%' }}/>
              </Form.Item>
              {isNewAcknowledgmentOverrideReportEmail || (data?.lastExecutionDate=='' || data?.lastExecutionDate==null || data?.lastExecutionDate==undefined)? 
                <Form.Item  name="lastExecutionDate" label="LastExecutionDate">
                <DatePicker format='MM/DD/YYYY' placeholder='MM/DD/YYYY' style={{ width: '100%' }}/>
                </Form.Item>
                :<Form.Item  name="lastExecutionDate" label="LastExecutionDate"
                  initialValue={(data?.lastExecutionDate!='' || data?.lastExecutionDate!=null || data?.lastExecutionDate!=undefined)? dayjs(data?.lastExecutionDate):null} 
                  getValueProps={(i) => ({ value: ((data?.lastExecutionDate!='' || data?.lastExecutionDate!=null || data?.lastExecutionDate!=undefined)?dayjs(i):null)})}
                >
                <DatePicker defaultValue={((data?.lastExecutionDate!='' || data?.lastExecutionDate!=null || data?.lastExecutionDate!=undefined)?dayjs(data?.lastExecutionDate):null)} format='MM/DD/YYYY' 
                placeholder='MM/DD/YYYY' 
                style={{ width: '100%' }}/>
                </Form.Item>
              }

              <Form.Item name="isActive" label="IsActive" initialValue={isNewAcknowledgmentOverrideReportEmail ?true : data?.isActive}>
              <Switch />
              </Form.Item>
              <Form.Item wrapperCol={{ offset: 4, span: 12 }}>
                <Space>
                  <Button type="primary" htmlType="submit" disabled={disabledSave && !isNewAcknowledgmentOverrideReportEmail}>
                    {isNewAcknowledgmentOverrideReportEmail ? 'Add Acknowledgement Reconciliation Report' : 'Save Acknowledgement Reconciliation Report'}
                  </Button>
                  <Button htmlType="button" onClick={handleCancel}>
                    Cancel
                  </Button>
                </Space>
              </Form.Item>
            </Form>
            :<Descriptions title="">
            <Descriptions.Item label="Name">{data?.name}</Descriptions.Item>
            <Descriptions.Item label="ReceipientEmail">{data?.receipientEmail}</Descriptions.Item>
            <Descriptions.Item label="Frequency">{data?.frequency}</Descriptions.Item>
            <Descriptions.Item label="StartDate">{dayjs(data?.startDate).format('MM/DD/YYYY')}</Descriptions.Item>
            <Descriptions.Item label="LastExecutionDate">{data?.lastExecutionDate=='' || data?.lastExecutionDate==null?null:dayjs(data?.lastExecutionDate).format('MM/DD/YYYY')}</Descriptions.Item>
            <Descriptions.Item label="IsActive">{data?.isActive?'Yes':'No'}</Descriptions.Item>
            <Descriptions.Item label="Entered By">{data?.enteredBy}</Descriptions.Item>                     
            <Descriptions.Item label="Updated By">{data?.updatedBy}</Descriptions.Item>            
            <Descriptions.Item label="Entered By Date">{ConvertUTCtoCDT(data?.enteredByDate||'')}</Descriptions.Item>   
            <Descriptions.Item label="Updated By Date">{ConvertUTCtoCDT(data?.updatedByDate||'')}</Descriptions.Item>
          </Descriptions>}
          </Spin>
        </Card>
        {!isNewAcknowledgmentOverrideReportEmail && !isFetching?
        <Card>
          <AcknowledgmentOverrideReportEmailFiltersScreen acknowledgementReconciliationReportId = {isNewAcknowledgmentOverrideReportEmail?0:Number(Id)} 
          acknowledgementReconciliationReportName = {isNewAcknowledgmentOverrideReportEmail?'':data?.name} />
        </Card>:<></>
        }
      </PageHeader>
    </div>
  );
}
